import webApi, { baseURL } from "../../WebApi/WebApi";

export const getAllModulelist = async () => {
    return await webApi.get(`/customer/employee/list-module`,
    );
}


//rolelist

export const getAllRolelist = async () => {
    return await webApi.get(`/user/list-job-role`,
    );
}

//ADD USER/EMPLOYEE


export const getNewUser = async (data, onSuccess, onFailure) => {
  //  console.log(data, "formData")
    try {
        const res = await webApi.post(
            `/customer/employee/add-employee`, data
        );
        if (res.status === 200) {
            const r = res.data;
          //  console.log(r, "rerere")
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
      //  console.log("fdgdf")
    }
};

//list all user or employee

export const getAllUserDetailslist = async (data, departmentId, unitId) => {
  //  console.log(data, departmentId, "dsadsa")
    return await webApi.post(`/customer/employee/list-employee?searchKeyword=${data}`,
        {
            departmentId: Number(departmentId) ? Number(departmentId) : "",
            unitId: Number(unitId) ? Number(unitId) : "",
        },
    );
}

//user details by id
export const getUserById = async (data) => {
  //  console.log(data, "datata")
    return await webApi.post(`/customer/employee/get-employee-by-id`,
        {
            id: data
        });
}



//edit user


export const getEditUser = async (data, onSuccess, onFailure) => {
  //  console.log(data, "formData")
    try {
        const res = await webApi.post(
            `/customer/employee/edit-employee`, data
        );
        if (res.status === 200) {
            const r = res.data;
          //  console.log(r, "rerere")
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
      //  console.log("fdgdf")
    }
};


export const getActiveUser = async (module,id,isactive, onSuccess, onFailure) => {
    try {
        const res = await webApi.post(
            `/customer/common/is-active`, {

            "module": module,
            "id": id,
            "isActive": isactive

        }
        );
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
      //  console.log("fdgdf")
    }
};

export const createAccessToken = async (data) => {
    try {
        const res = await webApi.post(
            `/user/create-auth-token`,
            data
        );
        if (res.status === 200) {
            const r = res.data;
            return r;
        } else {
            return res.data
            // onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
      //  console.log(error)
    }
};

export const updateAccessToken = async (data) => {
    try {
        const res = await webApi.post(
            `/user/edit-auth-token`,
            data
        );
        if (res.status === 200) {
            const r = res.data;
            return r;
        } else {
            return res.data
            // onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
      //  console.log(error)
    }
};

export const listAuthToken = async (onSuccess, onFailure) => {
    try {
        const res = await webApi.get(
            `/user/list-auth-token`
        );
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
      //  console.log(error)
    }
};

export const deleteAuthToken = async (tokenId,onSuccess, onFailure) => {
    try {
        const res = await webApi.post(
            `/user/delete-auth-token`,{tokenId}
        );
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
      //  console.log(error)
    }
};